_ = require('underscore')

module.exports = require('../abstract').extend
  template: require('./index.pug')

  data: ->
    recaptchaId:   null
    loadingTrials: 0

  computed:

    id: ->
      @_id or= _.uniqueId('recaptcha')

  methods:

    getRecaptchaResponse: ->
      grecaptcha.getResponse(@recaptchaId)

    loadRecaptcha: ->
      if window.grecaptcha? && _.isFunction(window.grecaptcha.render)
        @.$set @, 'loadingTrials', 0
        @.$set @, 'recaptchaId', window.grecaptcha.render(@id, {
          sitekey: @.$store.state.settings.recaptcha.sitekey
        })
      else if @loadingTrials <= 5
        setTimeout =>
          @.$set @, 'loadingTrials', @loadingTrials + 1
          @loadRecaptcha()
        , 500

  mounted: ->
    @loadRecaptcha()



// WEBPACK FOOTER //
// ./assets/js/shared/components/recaptcha/index.coffee